const isPhoneNumber = (value: string): boolean => {
  if (value === '') return true
  const phoneNumberRegExp =
    /^\+?[0-9]{1,4}?[-. ]?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{3,4})$/

  return phoneNumberRegExp.test(value)
}

export default isPhoneNumber
